export default {
      id: "icon-event-usage",
      viewBox: "0 0 24 24",
      url: "../icon/" + "icons.svg#icon-event-usage",
      toString: function () {
        return this.url;
      }
    }